//sets purposes to popualte the boxes
//sets <bool> REI info:

export function initPurposes(
  creditTransferTypes,
  props,
  setPurposes,
  setShowREAInfoFill,
) {
  if (creditTransferTypes?.length) {
    const purposes = JSON.parse(
      creditTransferTypes.filter((f) => f.name === 'Client Transfer')[0]
        .purpose,
    ).purposes;
    setPurposes(purposes);
  }
  if (props?.tenant?.routingType === 'agent') {
    setShowREAInfoFill(false);
  }
}
